'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCPF = exports.defaultCNPJ = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.normalizers');
var _wavfichacertaFichacertaUtils2 = require('@bit/wavfichacerta.fichacerta.utils.validators');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var defaultCNPJ = exports.defaultCNPJ = function defaultCNPJ() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  return {
    name: 'cnpj',
    label: 'CNPJ',
    isRequired: true,
    size: size,
    type: 'maskedText',
    normalize: _wavfichacertaFichacertaUtils.removeNonDigit,
    props: {
      regex: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    validate: _wavfichacertaFichacertaUtils2.cnpjValidation
  };
};
var defaultCPF = exports.defaultCPF = function defaultCPF() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  return {
    name: 'cpf',
    label: 'CPF',
    isRequired: true,
    size: size,
    type: 'maskedText',
    normalize: _wavfichacertaFichacertaUtils.removeNonDigit,
    props: {
      regex: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    validate: _wavfichacertaFichacertaUtils2.cpfValidation
  };
};